export const AnalyticsEvent = {
  UserSignedUp: 'User Signed Up',
  UserLoggedIn: 'User Logged In',
  UserLoggedOut: 'User Logged Out',
  AvatarPageViewed: 'Avatar Page Viewed',
  FreeAvatarItemEquipped: 'Free Avatar Item Equipped',
  AvatarItemPurchased: 'Avatar Item Purchased',
  AvatarSelected: 'Avatar Selected',
  LessonStarted: 'Lesson Started',
  LessonCompleted: 'Lesson Completed',
  ActivityStarted: 'Activity Started',
  ActivityResumed: 'Activity Resumed',
  ActivityCompleted: 'Activity Completed',
  ActivityReportViewed: 'Activity Report Viewed',
  TaskSubmitted: 'Task Submitted',
  TypeInsteadClicked: 'Type Instead Clicked',
  LeaderboardViewed: 'Leaderboard Viewed',
  InAppBrowserNoticeShown: 'In-App Browser Notice Shown',
  InAppBrowserNoticeAction: 'In-App Browser Notice Action',
} as const;
